/* eslint-disable no-multi-assign */
import { RequestHelp_Util } from './RequestHelp_Util';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../../OMT_UI/OMT_UI_SquareButton';
import { GiftGraphic } from '../GiftUI/GiftGraphic';

/**
  * Creates the button that brings you to the requestHelp window
  * Used in window_level and window_dailyChallenge.
  * Config can be anything. Just something to pass back into the window to be remade
  *
  * config = {
  *   onButtonDown: function,
  *   creationCallback?: function
  * }
  * @param {object} config
 * @author Sandra Koo
 */
export class RequestHelp_InitiateButton extends Phaser.Group {
  constructor(inGame, inParent, config) {
    super(inGame, inParent);

    this.createButton(config);
  }

  destroy() {
    super.destroy();
    this.onChildInputDown.removeAll();
    this.tweenArray.forEach((tween) => {
      tween.stop();
    });
    this.tweenArray = [];
  }

  async createButton(config) {
    const actualRequestBtn = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.blue,
        dimensions: {
          width: 309,
          height: 100,
        },
        extraDetail: false,
      },
    });
    const reqHelpText = new G.Text(0, 0, OMT.language.getText('Request Help'), { style: 'font-white', align: 'center' }, 0.5, actualRequestBtn.width * 0.7, actualRequestBtn.height, true, 'center');
    // actualRequestBtn.addTextLabel('font-white', OMT.language.getText('Request Help'), 70, -2, -2, 170);
    this.onChildInputDown.add(config.onButtonDown);

    const gift = new GiftGraphic(-actualRequestBtn.width / 2, -10, { giftType: 1, useFullGift: true }, null);
    // const gift = G.makeImage(-actualRequestBtn.width / 2, -10, 'gift', 0.5, null);
    const giftScale = 100 / 187;
    const giftOriWidth = gift.width = gift.height = gift.height * giftScale; /* eslint-disable-line operator-assignment */

    // SHAKE GIFT BOX Tweens
    this.tweenArray = [];
    const shakeTween1 = game.add.tween(gift).to({ angle: -5, width: giftOriWidth * 1.05, height: giftOriWidth * 1.05 }, 500, Phaser.Easing.Sinusoidal.In);
    const shakeTween2 = game.add.tween(gift).to({ angle: 5 }, 50, Phaser.Easing.Sinusoidal.InOut, false, 0, 2, true);
    const shakeTween3 = game.add.tween(gift).to({ angle: 0, width: giftOriWidth, height: giftOriWidth }, 500, Phaser.Easing.Sinusoidal.InOut, false);
    const delayTween = game.add.tween(gift).to({ angle: 0 }, 5000);
    shakeTween1.chain(shakeTween2);
    shakeTween2.chain(shakeTween3);
    shakeTween3.chain(delayTween);
    delayTween.chain(shakeTween1); // loops the shake tweens
    gift.shakeTween = shakeTween1; // Saving it for later
    game.time.events.add(5000, () => { // After 5s, begin the shake
      gift.shakeTween.start();
    }, this);
    this.tweenArray.push(shakeTween1);
    this.tweenArray.push(shakeTween2);
    this.tweenArray.push(shakeTween3);
    this.tweenArray.push(delayTween);

    const avatar = new Phaser.Group(G.Game, null); // Avatar group base for now
    const avatarBelow = new Phaser.Graphics(game); // The background of the Avatars
    avatarBelow.beginFill(0xbd5728);
    avatarBelow.drawRect(0, 0, 80, 80);
    avatarBelow.endFill();
    avatar.addChild(avatarBelow);
    const avatarFrame = G.makeImage(0, 0, 'avatar_frame', 0.5, null);
    avatarFrame.width = avatarFrame.height = avatarBelow.height * 1.15;

    this.addChild(actualRequestBtn);
    this.addChild(reqHelpText);
    this.addChild(gift);
    this.addChild(avatar);
    this.addChild(avatarFrame); // The size of requestHelpBtn is set so askForHelp has proper width

    this.askForHelp = new G.Text(0, 0, OMT.language.getText('Ask a friend for a Free Booster!'), {
      style: 'font-white',
      fontSize: 24,
      align: 'center',
      lineSpacing: -10,
    }, 0.5, this.width + 50, 120, false, 'center', false, true, true);
    this.askForHelp.y = actualRequestBtn.y + (actualRequestBtn.height + this.askForHelp.height) / 2;
    this.add(this.askForHelp);
    this.renderedBounds = this.getBounds(this).clone();
    this.renderedBounds.height -= 30; // this is mostly used for positioning other things and 30px is getting in the way!

    const potentialFriends = await RequestHelp_Util.retrieveFriends(); // thread gets stalled here for this
    const friendData = potentialFriends.off; // Off cooldown friends
    for (let i = friendData.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = friendData[i];
      friendData[i] = friendData[j];
      friendData[j] = temp;
    }
    let avatarCounter = 0;
    let avatarList;
    const isSolo = friendData.length === 0;
    if (!isSolo) {
      // grabs avatar urls if not solo
      avatarList = friendData.map((a) => a.image);
    } else {
      avatarList = ['avatar_f', 'avatar_m'];
    }
    avatarBelow.x = avatarBelow.y = -avatarBelow.height / 2;
    const avatarA = G.makeImage(0, 0, 'avatar_m', 0.5, null);
    const avatarB = G.makeImage(0, 0, 'avatar_f', 0.5, null);
    avatarBelow.width = avatarBelow.height = avatarA.width = avatarA.height = avatarB.width = avatarB.height = 80;
    avatarFrame.x = avatar.x = -10 + actualRequestBtn.width / 2;
    avatar.addChild(avatarB);
    avatar.addChild(avatarA);

    const avatarRotation = () => {
      const nextAvatarUrl = avatarList[avatarCounter % avatarList.length];
      if (isSolo) {
        RequestHelp_Util.changeAvatar(avatarA, avatarB, avatar, nextAvatarUrl);
      } else {
        G.getExtTexture(nextAvatarUrl, (textureName) => { RequestHelp_Util.changeAvatar(avatarA, avatarB, avatar, textureName); });
      }
      avatarCounter++;
    };
    const avatarChangeDelay = game.time.events.repeat(3000, Infinity, () => { // Rotates avatar every 3s
      if (avatar.game) {
        avatarRotation();
      } else {
        game.time.events.remove(avatarChangeDelay);
      }
    }, this);

    // Try to immediately change or load to the first friend
    avatarRotation();

    if (config.creationCallback) {
      config.creationCallback();
    }
  }
}
